import React, { useState } from 'react'
import { connect } from 'react-redux'
import { PageHeader, Menu, Dropdown, Button, Tag, Result } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';

import {getStudentreports} from '../actions/studentreport';

const Reports = (props) => {
    const [reports, setreports] = useState({})
    
    const get_rows = (id, arrays) =>{
    if(Array.isArray(arrays)){
         return arrays[id]
    }else{
        return {}
    }
    }
  
    let arr_reports = []
    Object.keys(props.reports).forEach(schoolid=>{
        let sessions = props.reports[schoolid]
        Object.keys(sessions).forEach(sessionid=>{
            let arr = {}
            let sch = get_rows(schoolid, props.schools)
            let ses = get_rows(sessionid, props.sessions)
            arr['schoolname'] = sch.abbrv || ''
            arr['sessionname'] = ses.name || ''
            arr['schooldata'] = sch
            arr['sessiondata'] = ses
            arr_reports.push(arr)              
        })
    })
    const loadResult = (d) =>{
        let session = d
            let params = {
            data:JSON.stringify(
            {
                  'sessionid':session,
                  'studentid' : props.mid
              }),
              cat:'selectreportmain',
              table:'studentscore',
              narration:'get fees'
            }
            props.getStudentreports(params)

    }
    

    

   

    const student_fees = Array.isArray(props.studentfee) ? props.studentfee || [] : []
    
    return (
        <div>
            <PageHeader
                title="Feedback"
                className="site-page-header no-print"
                subTitle=""
                tags={<Tag color="blue">Active</Tag>}
                extra={[,]}
                avatar={{ src: process.env.PUBLIC_URL+'/asset/icons/feedback.png' }}    
            ></PageHeader>
                <Result
                    status="403"
                    title="WORKING ON IT"
                    subTitle="Sorry, on construction."
                    extra={<Button type="primary">Back Home</Button>}
                />
            
        </div>
    )
}

const mapStateToProps = (state) => ({
    reports:state.reportReducer.reports,
    schools:state.reportReducer.schools,
    claszs:state.reportReducer.claszs,
    studentreport:state.studentreportReducer.studentreports,
    mid:state.userReducer.mid
})

const mapDispatchToProps = {
    getStudentreports
}

export default connect(mapStateToProps, mapDispatchToProps)(Reports)
